import _ from 'lodash'

export const getLeadIdParam = (state, props) => _.get(props, 'match.params.leadId')



// WEBPACK FOOTER //
// ./src/selectors/lead/lead.js